import { createStore } from 'vuex'
import VuexPersistence from 'vuex-persist'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

export default createStore({
  state: {
    sidebarVisible: '',
    sidebarUnfoldable: false,
    access_token: null,
    refresh_token: null,
    user: null,
    all_networks: null,
    network_id: process.env.VUE_APP_NETWORK_ID
  },
  mutations: {
    toggleSidebar(state) {
      state.sidebarVisible = !state.sidebarVisible
    },
    toggleUnfoldable(state) {
      state.sidebarUnfoldable = !state.sidebarUnfoldable
    },
    updateSidebarVisible(state, payload) {
      state.sidebarVisible = payload.value
    },
    setAccessToken(state, access_token) {
      state.access_token = access_token
    },
    setRefreshToken(state, refresh_token) {
      state.refresh_token = refresh_token
    },
    setUser(state, user) {
      state.user = user
    },
    setAllNetworks(state, networks) {
      state.all_networks = networks
      if (networks && networks.length === 1) {
        state.network_id = networks[0].organization.username
      }
    },
    setNetworkId(state, network_id) {
      state.network_id = network_id
    },
    setTotpSecret(state, totp_secret) {
      state.totp_secret = totp_secret
    },
    setTotpInterval(state, totp_interval) {
      state.totp_interval = Number(totp_interval)
    },
  },
  actions: {},
  modules: {},
  plugins: [vuexLocal.plugin],
})
